const languages = require('./languages');

const getDefaultLanguage = () => languages.find(lang => lang.default);

module.exports = getDefaultLanguage;
